import React, { useState } from 'react';
import { MenuIcon, XIcon, ArrowUpRightIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm" data-id="element-168">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center" data-id="element-169">
        <div className="flex items-center" data-id="element-170">
          <a href="#" className="flex items-center" data-id="element-171">
            <img src="https://cdn.magicpatterns.com/uploads/tV2XtCvVgeGoehCycn1vDo/SS_Logo.png" alt="Sales Source Logo" className="h-24" data-id="element-172" />
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-173">
          <a href="#services" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors" data-id="element-174">
            Services
          </a>
          <a href="#process" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors" data-id="element-175">
            How It Works
          </a>
          <a href="#results" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors" data-id="element-176">
            Success Stories
          </a>
          <a href="#resources" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors" data-id="element-177">
            Resources
          </a>
          <a href="#about" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors" data-id="element-178">
            About
          </a>
          <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="bg-[#B87333] text-[#1B2A4A] px-4 py-2 rounded-md font-medium hover:bg-[#B87333]/90 transition-all flex items-center gap-2 shadow-sm" data-id="element-179">
            Talk to us <ArrowUpRightIcon size={16} data-id="element-180" />
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-[#1B2A4A]" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-181">
          {isMenuOpen ? <XIcon size={24} data-id="element-182" /> : <MenuIcon size={24} data-id="element-183" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white w-full py-5 px-6 shadow-md border-t border-gray-100 absolute" data-id="element-184">
          <nav className="flex flex-col space-y-4" data-id="element-185">
            <a href="#services" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-186">
              Services
            </a>
            <a href="#process" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-187">
              How It Works
            </a>
            <a href="#results" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-188">
              Success Stories
            </a>
            <a href="#resources" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-189">
              Resources
            </a>
            <a href="#about" className="text-[#1B2A4A] hover:text-[#B87333] font-medium transition-colors py-1" onClick={() => setIsMenuOpen(false)} data-id="element-190">
              About
            </a>
            <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="bg-[#B87333] text-[#1B2A4A] px-4 py-3 rounded-md font-medium hover:bg-[#B87333]/90 transition-all inline-flex items-center gap-2 w-fit shadow-sm mt-2" onClick={() => setIsMenuOpen(false)} data-id="element-191">
              Talk to us <ArrowUpRightIcon size={16} data-id="element-192" />
            </a>
          </nav>
        </div>}
    </header>;
};